module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"panel color-picker\"> <label>Color</label> <div class=\"input-group\"> <input type=\"text\" class=\"form-control form-control-lg\" value=\"")
    ; __append(escapeFn( locals.color ))
    ; __append("\" placeholder=\"#0000FF\"> <span class=\"input-group-addon\"><span class=\"color-preview\"></span></span> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/color_picker.ejs
// module id = 881
// module chunks = 1